const getLocalStorageItem = (key, defaultValue = null) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  } catch (error) {
    console.error(`Error al obtener '${key}' del localStorage:`, error);
    return defaultValue;
  }
};

export default getLocalStorageItem;